<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>FILTRI</v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="4" sm="5" xs="12">
                <v-select :items="shopGroupsList" v-model="filters.selectedGroup" label="Gruppi" item-text="name"
                  @change="getProduct()" item-value="id">
                </v-select>
              </v-col>
              <v-col md="6" sm="5" xs="12">
                <v-autocomplete clearable :items="suppliers" v-model="filters.selectedSupplier" label="Fornitori"
                  item-text="an_descr1" item-value="an_conto" @change="getProduct()">
                </v-autocomplete>
              </v-col>
              <v-col md="2" sm="5" xs="12">
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-card>
          <v-card-text>
            <v-row v-if="filters.selectedGroup && filters.selectedSupplier">
              <v-col md="6" xs="12">
                <v-text-field v-model="infoGroupSupplier.header_text" label="Testo libero" outlined
                  @change="saveGroupData">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table v-model="selected" :headers="headers" :items="products" :items-per-page="20" :footer-props="{
            'items-per-page-options': [20, 50, 100, 200, -1],
          }" item-key="id" show-select single-select class="elevation-1" :loading="loading"
            loading-text="Caricamento in corso..." calculate-widths dense>
            <template v-slot:header.tot_euro="{header}">
              TOTALE <br />
              {{calcoloTotale() | formatEuro}}
            </template>
            <template v-slot:top>
              <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                  <v-card-title>
                    Scrivi Note
                  </v-card-title>
                  <v-card-subtitle>
                    {{ editedItem.ar_descr }}
                  </v-card-subtitle>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-textarea solo name="input-7-4" v-model="editedItem.note" label="Solo textarea">
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Annulla
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      Salva
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:item.foto="{ item }">
              <div style="text-align: center">
                <a :href="getImagePath(item.ar_codart)" _target="_blank">
                  <img height="60px" :src="getImagePath(item.ar_codart)"
                    onerror="javascript: this.src='/no_image.jpg';" />
                </a>
              </div>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, item }">
              <v-checkbox v-model="isSelected" @change="selectedChange(item, isSelected)"></v-checkbox>
            </template>
            <template v-slot:item.ar_codart="{ item }">
              <a :href="'/product?id=' + item.ar_codart" target="_blank">{{
              item.ar_codart
              }}</a>
            </template>
            <template v-slot:item.lc_prezzo5="{ item }">
              <span v-if="getGroupType()=='franchise'">
                {{calcoloScontoFrancising(item) | formatEuro}}
              </span>
              <span v-else>{{ item.lc_prezzo5 | formatEuro }}</span>
            </template>
            <template v-slot:item.qta_ideale="{ item }">
              <v-text-field v-model="item.qta_ideale" min="0" type="number" dense solo @change="saveProduct(item)">
              </v-text-field>
            </template>
            <template v-slot:item.qta_ordinato="{ item }">
              <v-text-field min="0" v-model="item.qta_ordinato" type="number" dense solo
                @change="calcTotConf(item); calcTotEuro(item); saveProduct(item);">
              </v-text-field>
            </template>

            <template v-slot:item.tot_euro="{ item }">
              {{ item.tot_euro | formatEuro }}
            </template>
            <template v-slot:item.note="{ item }">
              <v-icon :color="item.note ? 'green darken-2' : 'blue darken-2'" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">

</style>
<script>
import requests from "../requests";
import helpers from "../helpers";
export default {
  name: "create-order-page",
  data: () => {
    return {
      loading: false,
      families: [],
      selected: [],
      collectionData: [],
      suppliers: [],
      products: [],
      shopGroupsList: [],
      selectedGroupObject: null,
      infoGroupSupplier: {},
      defaultItem: {
        ar_descr: "",
        note: ""
      },
      editedItem: {
        ar_descr: "",
        note: ""
      },
      dialog: false,
      filters: {
        selectedSupplier: null,
        selectedGroup: null,
      },
      groupData: {
        headerText: ""
      }
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    'filters.selectedGroup': function () {
      this.getGrupShopSupplierInfo();
    },
    'filters.selectedSupplier': function () {
      this.getGrupShopSupplierInfo();
    }
  },
  computed: {
    headers() {
      return [
        { value: "foto", sortable: false },
        //{ text: "ID", value: "shopify_id" },
        {
          text: "Cod Articolo",
          value: "ar_codart",
          filter: (f) => {
            if (!this.filters.ar_codart) return true;
            return f.indexOf(this.filters.ar_codart) > -1;
          },
        },
        {
          text: "Desc",
          value: "ar_descr",
          filter: (f) => {
            if (!this.filters.ar_descr) return true;
            return f.indexOf(this.filters.ar_descr.toUpperCase()) > -1;
          },
        },
        {
          text: "Cod Forn.",
          value: "ar_codforn",
          filter: (f) => {
            if (!this.filters.ar_codforn) return true;
            return f == this.filters.ar_codforn;
          },
        },
        {
          text: "Barcode",
          value: "bc_code",
          filter: (f) => {
            if (!this.filters.bc_code) return true;
            return f == this.filters.bc_code;
          },
        },
        {
          text: "PRZ ACQ",
          value: "lc_prezzo5",
        },
        {
          text: "CodArt Forn",
          value: "xx_codarfo",
        },
        {
          text: "INNER",
          value: "ar_inner",
        }, {
          text: "CARTONE",
          value: "ar_cartonaggio"
        },
        {
          text: "QTA IDEALE",
          value: "qta_ideale",
        },
        {
          text: "ORDINATO",
          value: "qta_ordinato",
        },
        {
          text: "TOT CONF",
          value: "tot_conf",
        },
        {
          text: "TOT EURO",
          value: "tot_euro",
        },
        {
          text: "NOTE",
          value: "note",
        },
      ];
    },
  },
  mounted() {
    console.log("Create order page Mounted.");
    this.getSuppliers();
    requests.getShopGroupList().then(res => {
      this.shopGroupsList = res.data;
    });
  },

  filters: {
    formatEuro(number) {
      if (_.isNaN(number)) return 0;
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }).format(number);
    },
  },
  methods: {
    calcoloTotale() {
      let sum = 0;
      _.forEach(this.products, (item) => {
        if (item.linked == 1) {
          let prezzo = item.lc_prezzo5;
          if (this.getGroupType() == 'franchise') prezzo = this.calcoloScontoFrancising(item);
          sum += (item.qta_ordinato * prezzo);
        }
      });
      return sum;
    },
    getGroupType() {
      let a = _.find(this.shopGroupsList, { id: this.filters.selectedGroup });
      return a.type;
    },
    getGrupShopSupplierInfo() {
      if (this.filters.selectedGroup && this.filters.selectedSupplier) {
        requests.getGrupShopSupplierInfo(this.filters.selectedGroup, this.filters.selectedSupplier).then(res => {
          this.infoGroupSupplier = res.data;
        });
      }
    },
    getSuppliers() {
      requests.getSuppliers().then(res => {
        this.suppliers = res.data;
      });

    },

    saveProduct(item) {
      requests.saveProductToListOrder(item);
    },

    getImagePath(a) {
      return helpers.getImagePath(a);
    },

    selectedChange(item, isSelected = null) {
      if (isSelected != null) {
        item.linked = isSelected;

        if (isSelected == 0) {
          this.selected.splice(_.findIndex(this.selected, item), 1);
        } else {
          this.selected.push(item);
        }
      }
      item.shop_group_id = this.filters.selectedGroup;
      requests.saveProductToListOrder(item);
    },
    calcoloScontoFrancising(product) {
      let prezzo = product.lc_prezzo2;
      let sconto1 = product.so_sconto1l3;
      let sconto2 = product.so_sconto2l3;
      let ris = prezzo - (prezzo * sconto1) / 100;
      return ris - (ris * sconto2) / 100;
    },
    calcTotConf(item) {
      let num = (parseInt(item.qta_ordinato) / parseInt(item.ar_cartonaggio));
      if (_.isNaN(num)) num = 0;
      num = Math.ceil(num);
      item.tot_conf = num;
    },

    calcTotEuro(item) {
      let prezzo = item.lc_prezzo5;
      if (this.getGroupType() == 'franchise') prezzo = this.calcoloScontoFrancising(item);
      let num = (item.qta_ordinato * prezzo);
      if (_.isNaN(num)) num = 0;
      item.tot_euro = num;
    },

    getProduct() {
      this.loading = true;
      requests.getProductBySupplier(this.filters.selectedSupplier, this.filters.selectedGroup).then((res) => {
        _.forEach(res.data, (d, index) => {
          this.$set(res.data[index], 'tot_conf', 0);
          this.$set(res.data[index], 'tot_euro', 0);
          this.calcTotConf(d);
          this.calcTotEuro(d);

          if (d.linked == 1) this.selected.push(d);
        });
        this.products = res.data;
        this.loading = false;
      });
    },
    saveGroupData() {
      requests.saveShopGroupData(this.filters.selectedGroup, this.filters.selectedSupplier, this.infoGroupSupplier);
    },
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    save() {
      this.selectedChange(this.editedItem);
      this.close();
    },
    restockReset(supId) {
      if (window.confirm("Azzerare l'ordine?"))
        requests.restockReset(supId);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
